<svg viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2a6 6 0 1 1 0-12 6 6 0 0 1 0 12zM2.049 24.004C2.549 18.922 6.842 15 12 15s9.45 3.921 9.951 9.003h2.008C23.452 17.842 18.292 13 12 13S.547 17.843.04 24.004h2.01zM12 15c5.158 0 9.45 3.921 9.951 9.003h2.008C23.452 17.842 18.292 13 12 13S.547 17.843.04 24.004h2.01C2.549 18.922 6.842 15 12 15z"/>
</svg>
